import { AccountMenu, parseAccessTokenClaims, useAuth } from '@beatq/shared';
import { getStoredOperatorEmail, setStoredOperatorEmail } from './adminSession.js';
import { isSuperAdminOperator } from './adminNav.js';
import { ChevronDown } from 'lucide-react';

function operatorLabel(accessToken: string | null): string {
  const email = getStoredOperatorEmail();
  if (email) return email;
  const claims = parseAccessTokenClaims(accessToken);
  if (claims.sub) {
    return claims.sub.length > 12 ? `${claims.sub.slice(0, 8)}…` : claims.sub;
  }
  return 'Operator';
}

export function AdminAccountMenu() {
  const { accessToken } = useAuth();
  const roleLabel = isSuperAdminOperator({
    email: getStoredOperatorEmail(),
    roles: parseAccessTokenClaims(accessToken).rol,
  })
    ? 'Super Admin'
    : 'Platform operator';
  return (
    <AccountMenu
      label={operatorLabel(accessToken)}
      subtitle={roleLabel}
      triggerClassName="admin-account-trigger"
      renderTrigger={({ label, initials }) => (
        <>
          <span className="admin-account-avatar">{initials}</span>
          <span className="admin-account-copy">
            <strong>{label}</strong>
            <small>{roleLabel}</small>
          </span>
          <ChevronDown size={14} aria-hidden="true" />
        </>
      )}
      onAfterLogout={() => setStoredOperatorEmail(null)}
    />
  );
}
